import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const Characteristics = () => import('./pages');

const moduleRoute = {
  path: 'master-data/characteristics',
  name: 'Characteristics',
  component: Characteristics,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.PRODUCT_CHARACTERISTICS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
